import { ValuationType } from '@aviv-estimation-funnel/estimation-data-models/enums/valuation-type.enum';

import { httpService } from './http';

interface estimationFeedbackPayload {
    value: string;
    expectedPrice?: number;
    reason?: string;
}

const WLEF_API_URL = process.env['NX_WLEF_API_URL'];
const WLEF_API_KEY = process.env['NX_WLEF_API_KEY'];

export const estimationFeedback = async (
    estimationId: string,
    valuationType: ValuationType,
    payload: estimationFeedbackPayload,
): Promise<any> => {
    const { data } = await httpService.put(
        `${WLEF_API_URL}/v1/estimations/${estimationId}/feedback/${valuationType.toLowerCase()}`,
        payload,
        {
            headers: {
                'x-api-key': WLEF_API_KEY,
            },
        },
    );
    return data;
};
